import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { CimSubstationPopupDetailsDto } from '../../../../models/cim-substation-map-details.model';
import { ToastrService } from 'ngx-toastr';
import { AcLineSegmentService } from '../../../../services/ac-line-segment.service';
import { AcLinesForSubstationAdvancedMapDataOut } from '../../../../models/ac-line-segment.model';

enum HeaderButton {
  Details,
  Schematic,
  Sphere
}

@Component({
  selector: 'lib-cim-substation-map-full-details',
  standalone: false,
  templateUrl: './cim-substation-map-full-details.component.html',
  styleUrl: './cim-substation-map-full-details.component.scss'
})
export class CimSubstationMapFullDetailsComponent implements OnInit {
  @Input() cimSubstation!: CimSubstationPopupDetailsDto;
  @Output() closeClicked = new EventEmitter<void>();
  @Output() acLineSchemaSelected = new EventEmitter<number>();

  coordinatesCopied = false;
  slrnCopied = false;

  activeButton: HeaderButton = HeaderButton.Details;
  HeaderButton = HeaderButton;

  showAcLinesPopup: boolean = false;
  acLinesData!: AcLinesForSubstationAdvancedMapDataOut;
  acLineCount = 0;
  incomingAcLinesCount = 0;
  outgoingAcLinesCount = 0;

  constructor(private acLineSegmentService: AcLineSegmentService, private toastr: ToastrService){}

  ngOnInit(): void {
    this.getAcLinesBySubstationId(this.cimSubstation.substationId);
  }

  getAcLinesBySubstationId(substationId: number): void {
    this.acLineSegmentService.getAcLinesBySubstationIdAdvancedMap(substationId).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 'OK' && responseData?.data) {
          const data = responseData.data;
          this.acLinesData = data;
          this.incomingAcLinesCount = data.incomingAcLines?.length ?? 0;
          this.outgoingAcLinesCount = data.outgoingAcLines?.length ?? 0;
          this.acLineCount = this.incomingAcLinesCount + this.outgoingAcLinesCount;
        } else {
          this.toastr.error(response.data.message)
        }
      },
      error: () => {
        this.toastr.error('Error occurred while loading AC Lines');
      }
    });
  }
  
  changeActiveButton(btn: HeaderButton) {
    this.activeButton = btn;
  }

  copyCoordinates(): void {
    const coordinates = `${this.cimSubstation.latitude}, ${this.cimSubstation.longitude}`;
    navigator.clipboard.writeText(coordinates).then(() => {
      this.coordinatesCopied = true;
      setTimeout(() => {
        this.coordinatesCopied = false;
      }, 1500);
    }).catch(err => {
      console.error('Could not copy text: ', err);
    });
  }

  copySlrn(): void {
    const slrn = `${this.cimSubstation.slrn}`;
    navigator.clipboard.writeText(slrn).then (() => {
      this.slrnCopied = true;
      setTimeout(() => {
        this.slrnCopied = false;
      }, 1500);
    }).catch(err => {
      console.error('Could not copy text', err);
    })
  }

  closeModal() {
    this.closeClicked.emit();
  }

  openAcLineSchematic(lineId: number) {
    this.acLineSchemaSelected.emit(lineId);
  }

  isOverflow(element: HTMLElement): boolean {
    return element.scrollWidth > element.clientWidth;
  }
}
